import '../css/app.css';
import $ from 'jquery';
import WebFont from 'webfontloader';
import mainMenu from './mainMenu';

$(() => {
  mainMenu();
});

WebFont.load({
  google: {
    families: ['Open Sans:300,400,600']
  }
});



// WEBPACK FOOTER //
// ./themes/app/assets/js/app.js